<template>
  <v-container>
    <!-- Caminho da estrada como imagem de fundo -->
    <div class="roadmap" @click="closeAllBalloons">
      <!-- Ícone 1: Brainstorm -->
      <div
        class="icon-container"
        :class="{ active: visible.brainstorm }"
        @click.stop="toggleText('brainstorm')"
        style="top: 37%; left: 16%;"
      >
        <img src="../../../../assets/modulo_01/infografico_interativo/icone_icone_1.svg" alt="Brainstorm Icon" class="icon" />
        <img
          v-if="visible.brainstorm"
          src="../../../../assets/modulo_01/infografico_interativo/balao_balao_1.svg"
          alt="Brainstorm Balloon"
          class="balloon balloon-brainstorm"
        />
      </div>

      <!-- Ícone 2: Invest Time -->
      <div
        class="icon-container"
        :class="{ active: visible.investTime }"
        @click.stop="toggleText('investTime')"
        style="top: 72%; left: 29%;"
      >
        <img src="../../../../assets/modulo_01/infografico_interativo/icone_icone_2.svg" alt="Invest Time Icon" class="icon" />
        <img
          v-if="visible.investTime"
          src="../../../../assets/modulo_01/infografico_interativo/balao_balao_2.svg"
          alt="Invest Time Balloon"
          class="balloon balloon-invest-time"
        />
      </div>

      <!-- Ícone 3: Deal With Companies -->
      <div
        class="icon-container"
        :class="{ active: visible.dealWithCompanies }"
        @click.stop="toggleText('dealWithCompanies')"
        style="top: 62%; left: 43%;"
      >
        <img src="../../../../assets/modulo_01/infografico_interativo/icone_icone_3.svg" alt="Deal Icon" class="icon" />
        <img
          v-if="visible.dealWithCompanies"
          src="../../../../assets/modulo_01/infografico_interativo/balao_balao_3.svg"
          alt="Deal Balloon"
          class="balloon balloon-deal"
        />
      </div>

      <!-- Ícone 4: Start Up -->
      <div
        class="icon-container"
        :class="{ active: visible.startUp }"
        @click.stop="toggleText('startUp')"
        style="top: 22%; left: 48%;"
      >
        <img src="../../../../assets/modulo_01/infografico_interativo/icone_icone_4.svg" alt="Start Up Icon" class="icon" />
        <img
          v-if="visible.startUp"
          src="../../../../assets/modulo_01/infografico_interativo/balao_balao_4.svg"
          alt="Start Up Balloon"
          class="balloon balloon-start-up"
        />
      </div>

      <!-- Ícone 5: Analyze the Stats -->
      <div
        class="icon-container"
        :class="{ active: visible.analyzeStats }"
        @click.stop="toggleText('analyzeStats')"
        style="top: 63%; left: 68%;"
      >
        <img src="../../../../assets/modulo_01/infografico_interativo/icone_icone_5.svg" alt="Analyze Stats Icon" class="icon" />
        <img
          v-if="visible.analyzeStats"
          src="../../../../assets/modulo_01/infografico_interativo/balao_balao_5.svg"
          alt="Analyze Stats Balloon"
          class="balloon balloon-analyze"
        />
      </div>

      <!-- Ícone 6: Goals -->
      <div
        class="icon-container"
        :class="{ active: visible.goals }"
        @click.stop="toggleText('goals')"
        style="top: 30%; left: 85%;"
      >
        <img src="../../../../assets/modulo_01/infografico_interativo/icone_icone_6.svg" alt="Goals Icon" class="icon" />
        <img
          v-if="visible.goals"
          src="../../../../assets/modulo_01/infografico_interativo/balao_balao_6.svg"
          alt="Goals Balloon"
          class="balloon balloon-goals"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      visible: {
        brainstorm: false,
        investTime: false,
        dealWithCompanies: false,
        startUp: false,
        analyzeStats: false,
        goals: false,
      },
    };
  },
  methods: {
    toggleText(section) {
      // Alterna a visibilidade do balão selecionado
      this.visible[section] = !this.visible[section];
    },
    closeAllBalloons() {
      // Oculta todos os balões ao clicar fora
      this.visible = {
        brainstorm: false,
        investTime: false,
        dealWithCompanies: false,
        startUp: false,
        analyzeStats: false,
        goals: false,
      };
    },
  },
};
</script>

<style>
/* Imagem de fundo da estrada */
.roadmap {
  background-image: url('.././../../../assets/modulo_01/infografico_interativo/fundo.svg');
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 800px; /* Ajuste o tamanho da imagem */
  position: relative;
}

/* Estilo para o contêiner de ícones */
.icon-container {
  position: absolute;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

/* Estilo para os ícones */
.icon {
  width: 80px; /* Ajuste o tamanho dos ícones */
  height: 80px;
  transition: transform 0.2s ease-in-out;
}

.icon:hover {
  transform: scale(1.1); /* Efeito de zoom no ícone */
}

/* Animação do balão */
@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* Estilo para os balões */
.balloon {
  position: absolute;
  top: -110%;
  left: -70%;
  transform: scale(0);
  opacity: 0;
}

/* Adicionar animação quando ativo */
.icon-container.active .balloon {
  animation: scaleIn 0.25s ease-out forwards;
}

/* Larguras personalizadas para cada balão */
.balloon-brainstorm {
  width: 200px;
}

.balloon-invest-time {
  width: 270px;
  z-index: 2;
}

.balloon-deal {
  width: 290px;
  z-index: 2;
}

.balloon-start-up {
  width: 250px;
}

.balloon-analyze {
  width: 220px;
}

.balloon-goals {
  width: 320px;
}

/* Animação ao clicar */
.icon-container.active .icon {
  transform: scale(1.1); /* Efeito de zoom no ícone */
}
</style>
